import { render, staticRenderFns } from "./agentPositionList.vue?vue&type=template&id=50651a1b"
import script from "./agentPositionList.vue?vue&type=script&lang=js"
export * from "./agentPositionList.vue?vue&type=script&lang=js"
import style0 from "./agentPositionList.vue?vue&type=style&index=0&id=50651a1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports